export default __webpack_public_path__ + "static/media/01-1.ea3c17a0.jpg";